import { useCreateProperty } from "@api/propertyService";
import PropertyEdit from "./PropertyEdit";

export default function PropertyCreate() {
    return <PropertyEdit
        mutation={useCreateProperty}
        title={'New Property'}
        create
    />
}
